import { TermEditorDropdown } from './TermEditorDropdown'
import Icon from 'components/Icon'
import * as editIcon from 'icons/checklist-pen.svg'
const termEditorDropdown = new TermEditorDropdown()

export const TermEditorIcon = Icon({
	icon: editIcon,
	onmousedown(event) {
		event.stopPropagation() // don't select in grid
	},
	onpointerdown(event) {
		event.stopPropagation() // don't select
	},
	onclick(event) {
		termEditorDropdown.term = this.term
		termEditorDropdown.type.put(this.type)
		termEditorDropdown.show(event)
	}
})
